export enum ProviderMedicalRole {
  therapist = "therapist",
  psychiatrist = "psychiatrist",
}
